import debug from 'bows';
import selectr from './_selectr';
import Twig from 'twig';

const log = debug('filters');

const dearray = function( str ) {
	return str.replace(/\[(\d+)?\]/, '');
}

export default class {
	constructor() {
		this.loading = false;
		this.loadingClass = 'filters--loading';

		this.form         = document.querySelector( '.filters__form' );
		this.pagination   = document.querySelector( '.filters__pagination' );
		this.items        = document.querySelector( '.filters__items' );
		this.share        = document.querySelector( '.filters__share' );
		this.selected     = document.querySelector( '.filters__selected' );
		this.title        = document.querySelector( '.filters__title' );
		this.twigs        = Array.from( document.querySelectorAll( 'script[type="text/twig"]' ) );

		this.exceptions = {
			outOfItems: 'There are no more items'
		}

		this.excerptOpts = {
			image: true,
			excerpt: true,
			issue: true,
			supplement: false,
		};

		this.templates = {};
		log(this);
	}

	init() {
		log('filters init');
		this.selectr();

		if ( this.items.getAttribute( 'data-excerpt-opts' ) ) {
			try {
				let excerptOpts = JSON.parse( this.items.getAttribute( 'data-excerpt-opts' ) );

				if ( excerptOpts ) {
					this.excerptOpts = Object.assign( this.excerptOpts, excerptOpts );
				}
			} catch(e) {
				// ignore
			}
		}

		if ( this.pagination ) {
			// delegate the event cause we're replacing the innerHTML wholesale
			this.pagination.addEventListener('click', (e) => {
				let node = e.target;
				while( node.tagName !== 'A' ) {
					if ( node === this.pagination ) {
						return;
					}

					node = node.parentNode;
				}

				e.preventDefault();
				this.load(node.href);
			});
		}

		// parse templates from the window
		if ( this.twigs.length > 0 ) {
			this.twigs.forEach(( twig ) => {
				let name = twig.dataset.template;
				this.templates[ name ] = Twig.twig({
					allowInlineIncludes: true,
					id: name,
					data: twig.innerHTML.trim()
				});
			});
		}

		if ( this.form ) {
			// handle form submission
			this.form.addEventListener( 'submit', (e) => {
				e.preventDefault();
				this.submit();
			});

			// submit form on facet changes
			this.form.addEventListener( 'change', () => this.submit() );

			// handle the pills removal clicks
			this.form.addEventListener( 'click', (e) => {
				let node = e.target;

				while( node && node.tagName !== 'A' && node !== this.selected ) {
					node = node.parentNode;
				}

				if ( node && node.classList.contains( 'filters__selected-facet' ) && node.dataset.facet && node.dataset.value ) {
					e.preventDefault();
					let facet = dearray( node.dataset.facet );
					let value = node.dataset.value;
					let selectr = this.facets[facet];

					log(selectr, facet, this.facets);

					selectr.setValue( value );
				}
			});
		}

		// handle the back/forward buttons
		window.addEventListener( 'popstate', ( e ) => {
			this.load(e.target.location.href, false);
		} );
	}

	submit() {
		if ( this.loading ) {
			return;
		}

		let url = this._buildUrl();

		if ( url !== location.href ) {
			this.load( url );
		}
	}

	// build the ajax url
	_buildUrl() {
		let formData = this.getFormData();
		let action = this.form.action;
		let params = new URLSearchParams( formData );
		let url = `${action}?${params}`;
		return url;
	}

	/**
	 * Load a url and handle the json response
	 *
	 * @param {string} url - load the url with an expected json response
	 * @param {boolean} pushHistory - whether to push the result onto the history stack
	 */
	load( url, pushHistory = true ) {

		this.loading = true;
		document.body.classList.add(this.loadingClass);

		let formRect = this.form.getBoundingClientRect();
		let scrollY = window.scrollY || document.body.scrollTop || document.documentElement.scrollTop;
		if ( formRect.top < scrollY ) {
			let top = formRect.top + scrollY;
			let header = document.getElementById('header');
			if ( header ) {
				top -= header.offsetHeight
			}

			log(formRect.top, scrollY, header.offsetHeight, top);

			window.scrollTo( 0, top );
		}

		const jsonUrl = `${url}${( url.indexOf('?') > -1 ) ? '&' : '?'}json=1`;

		window.fetch( jsonUrl, {
			headers: {
				'Accept': 'application/json',
			}
		} ).then( ( response ) => {
			log(response);

			if ( ! response.ok || response.headers.get( 'Content-Type' ) !== 'application/json' ) {
				throw this.exceptions.outOfItems;
			}

			return response.json();
		} ).then( ( payload ) => {
			// display the new items markup
			if ( this.items ) {
				this.items.innerHTML = '';
				if ( payload.posts && payload.posts.length > 0 ) {
					payload.posts.forEach((post) => {
						this.items.insertAdjacentHTML('beforeend', this.templates['partials/excerpt.twig'].render( Object.assign( this.excerptOpts, {
							post: post,
						} ) ) );
					});
				} else {
					throw this.exceptions.outOfItems;
				}
			}

			if ( this.title ) {
				this.title.innerHTML = this.templates['partials/archive-title.twig'].render(payload);
			}

			// pagination response
			if ( this.pagination ) {
				if ( payload.pagination ) {
					this.pagination.innerHTML = this.templates['pagination.twig'].render(payload.pagination);
				} else {
					this.pagination.style.display = 'none';
				}
			}

			// updated share template
			if ( this.share && payload.share ) {
				this.share.innerHTML = this.templates['partials/share.twig'].render(payload.share);
			}

			// selected filters template
			if ( payload.filters ) {
				// don't replace the form element itself so we don't have to listen again
				let filters = {
					search_query: payload.filters.search_query,
					filters: payload.filters,
					class: 'filters--archive',
					opts: {}
				};

				let formOpts = this.form.dataset.opts;

				log('formOpts', formOpts);

				if ( formOpts ) {
					try {
						filters.opts = Object.assign( filters.opts, JSON.parse( formOpts ) );
					} catch( e ) {
						log(e);
					}
				}

				if ( payload.orderby ) {
					filters.opts.orderby = payload.orderby;
				}

				log('filters', filters, filters.opts);

				let tempDiv = document.createElement('div');
				tempDiv.innerHTML = this.templates['partials/filters.twig'].render(filters);

				this.form.innerHTML = tempDiv.firstChild.innerHTML;
				this.selectr(); // re-init select items as selectr objects
			}

			// push onto the history stack
			if ( true === pushHistory ) {
				let title = payload.title ? payload.title : document.title;
				window.history.pushState( {}, title, url );
			}

			// reset the laoding view
			this.unload();
		} ).catch( ( err ) => {
			this.unload( err );
			this.pagination.innerHTML = '';

			if ( true === pushHistory ) {
				window.history.pushState( {}, null, url );
			}
		} );
	}

	/**
	 * Reset the view to an unloading state
	 * @param {string} msg - if a message, it will be displayed in place of this.items
	 */
	unload( msg = '' ) {
		this.loading = false;
		document.body.classList.remove( this.loadingClass );

		if ( msg && this.items ) {
			this.items.innerHTML = msg;
		}
	}

	getFormData() {
		return (typeof this.formData === 'object') ? this.formData : new FormData( this.form );
	}

	selectr() {
		log('selectr filters');
		// initialize selectr objects
		this.facets = {};
		log(Array.from( this.form.querySelectorAll( 'select' ) ));
		Array.from( this.form.querySelectorAll( 'select' ) ).forEach((select) => {
			this.facets[ dearray( select.name ) ] = selectr( select );
		});
	}
}
